<template>
  <div id="app">
    <loading v-show="loadingShow" />
    <section>
      <router-view v-if="routerViewShow"></router-view>
      <!-- <keep-alive>
        <router-view v-if="$route.meta.keepAlive && routerViewShow">
        </router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive && routerViewShow">
      </router-view> -->
    </section>
  </div>
</template>
<script>
import Loading from '@/components/loading.vue'
import { checkConfig, checkSend, noCheck } from '@/utils/viewConfig'
import { mapState } from 'vuex'
import { formatSearch, formatLocation } from '@/utils/util'
import { getLocationA, initMap } from '@/utils/getUserLocation'
// import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      latitude: 0,
      longitude: 0,
      show: true
    }
  },
  components: {
    Loading
  },
  created() {
    if (window.location.search) {
      formatSearch(window.location.search)
    }
    this.getInitInfo()
  },
  mounted() {},
  computed: {
    ...mapState(['loadingShow', 'routerViewShow'])
  },
  methods: {
    getInitInfo() {
      let obj = {}
      let url = window.location.href.split('#')[0]
      if (localStorage.getItem('userInfo')) {
        obj = JSON.parse(localStorage.getItem('userInfo'))
      }
      if (!obj.openId) {
        if (noCheck(url)) {
          alert('请在微信公众号菜单中打开')
          // this.getLocation()
          return
        }
        this.$store.commit('hideLoading')
        this.$store.commit('set_routerViewShow', true)
        return
      }
      let wechatCode = obj.partner
      let params = {
        wechatCode: wechatCode,
        url: url
      }

      let noConfig = checkConfig(url) // 检测当前页面是否不需要wx.config
      let noSend = checkSend(url) // 当前页面是否属于寄件内容
      if (noConfig || (this.$store.state.getLocationNum !== 1 && noSend)) {
        this.$store.commit('set_routerViewShow', true)
        return
      }
      // alert(JSON.stringify(params))
      this.$api.getWxInfo(params).then(res => {
        if (res) {
          obj = Object.assign(obj, { appId: res.appId })
          localStorage.setItem('userInfo', JSON.stringify(obj))
          this.initInfo = res
          this.initWx()
        }
      })
    },
    // 微信sdk配置
    initWx() {
      let that = this
      this.$store.commit('showLoading')
      global.wx.config({
        debug: false,
        appId: this.initInfo.appId,
        timestamp: this.initInfo.timestamp,
        nonceStr: this.initInfo.nonceStr,
        signature: this.initInfo.signature,
        jsApiList: [
          'chooseWxPay',
          'hideAllNonBaseMenuItem',
          'getLocation',
          'closeWindow'
        ]
      })
      global.wx.ready(function() {
        if (
          !window.location.href.split('#')[0].includes('goFastMail') ||
          that.$store.state.getLocationNum !== 1
        ) {
          that.$store.commit('hideLoading')
          that.$store.commit('set_routerViewShow', true)
          return
        }
        if (
          window.location.href.split('#')[0].includes('/goFastMail') ||
          window.location.href.split('#')[0].includes('/allServicePoint')
        ) {
          // 是否第一次获取位置
          if (that.$store.state.getLocationNum === 1) {
            global.wx.getLocation({
              type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
              success: function(res) {
                let obj = {
                  latitude: formatLocation(res.latitude),
                  longitude: formatLocation(res.longitude)
                }
                localStorage.setItem('location', JSON.stringify(obj))
                that.$store.commit('set_routerViewShow', true)
              },
              fail: function() {
                alert('获取定位失败！')
                that.$store.commit('hideLoading')
                that.$store.commit('set_routerViewShow', true)
              }
            })
          } else {
            that.$store.commit('hideLoading')
            that.$store.commit('set_routerViewShow', true)
          }
        }
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      })
      global.wx.error(function(res) {
        that.$store.commit('hideLoading')
        that.$store.commit('set_routerViewShow', true)
        alert(res.errMsg)
        alert('微信授权失败')
      })
    },
    async getLocation() {
      let AMap = await initMap()
      let res = await getLocationA(AMap)
      if (res.code === 1) {
        let obj = {
          latitude: formatLocation(res.latitude),
          longitude: formatLocation(res.longitude)
        }
        localStorage.setItem('location', JSON.stringify(obj))
      } else {
        // alert('定位获取失败')
      }
    }
  }
}
</script>
<style lang="scss">
* {
  padding: 0px;
  margin: 0px;
  list-style: none;
}
body {
  background-color: #f2f2f2;
}
</style>
